
import { defineComponent } from "vue";
import ConsumerContactActions from "@/components/dropdown/ConsumerContactActions.vue";
import ConsumerCancelActions from "@/components/dropdown/ConsumerCancelActions.vue";
import ConsumerDisputeActions from "@/components/dropdown/ConsumerDisputeActions.vue";
import ConsumerRefundDrawer from "@/layout/extras/ConsumerRefundDrawer.vue";


export default defineComponent({
  name: "kt-widget-11",
  components: { ConsumerContactActions,ConsumerCancelActions,ConsumerDisputeActions, ConsumerRefundDrawer, },
  props: {
    widgetClasses: String,
  },
  setup() {
    const list = [
      {
        product: {
          image: "/media/stock/600x400/img-38.jpg",
          name: "Nutra Ceuticals For You",
          specs: "www.nutraceutsyou.com",
          phone: "800-888-5554",
        },
        price: "$27.90",
        trial: "2023/01/23",
        producttype: {
          name: "Daily Face Cream",
          position: "Subscription",
          order: "ZZZSS333",
        },
        status: {
          label: "Approved",
          color: "primary",
        },
      },
      {
        product: {
          image: "/media/stock/600x400/img-48.jpg",
          name: "Cynergy Corp",
          specs: "www.dietarySupps.com",
          phone: "800-855-2341",
        },
        price: "$89.90",
        trial: "2023/01/13",
        producttype: {
          name: "Weight Loss Pills",
          position: "Subscription",
          order: "AA34343434",
        },
        status: {
          label: "Approved",
          color: "primary",
        },
      },
    ];

    return {
      list,
    };
  },
});
